/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props) {
  return props.value
}
